import { invoke } from "../invoke";
import { nothing } from "../maybe";
import { isCloudRoot } from "./projectRoot";
import {
  normalizePayload,
  type EditorPayload,
  type RawEditorPayload,
} from "../tauri/core";

/**
 * The mount-time bootstrap fetch, and `clearCloudEditorActiveBuffer` (client
 * memory only; no `zw-online` command yet). Everything else that used to live
 * here now goes through the unified `invoke()` in `lib/invoke.ts`.
 */

let current: EditorPayload | null = null;

function setPayload(payload: EditorPayload): EditorPayload {
  current = payload;
  return payload;
}

export async function openCloudEditorProject(
  rootPath: string,
): Promise<EditorPayload> {
  if (isCloudRoot(rootPath) === false) {
    throw new Error("Cloud editor requires a cloud:// project root");
  }
  const raw = await invoke<RawEditorPayload>("get_editor_payload");
  return setPayload(normalizePayload(raw));
}

/** Boot a share `/reader` session (cookie auth; root comes from payload). */
export async function openShareReaderProject(): Promise<EditorPayload> {
  const raw = await invoke<RawEditorPayload>("get_editor_payload");
  return setPayload(normalizePayload(raw));
}

export async function clearCloudEditorActiveBuffer(): Promise<void> {
  if (current === null) return;
  current = { ...current, activePath: nothing, content: "", synopsis: "" };
}
